/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Boilerrooms1Inputs */



/**
* | output |
* | --- |
* | "Boiler room(s)" |
*
* @param {Br_History_Key_Boilerrooms1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_boilerrooms1 = /** @type {((inputs?: Br_History_Key_Boilerrooms1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Boilerrooms1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Boiler room(s)")
	return /** @type {LocalizedString} */ ("Chaufferie(s)")
});
export { br_history_key_boilerrooms1 as "br_history_key_boilerRooms" }